module.exports = __webpack_public_path__ + "img/HIDDEN_HERO.51a4f963.png";